import { useEffect, useState } from "react";
import api from "@/lib/api";

export const percent = (rate) => `${Number((Number(rate) * 100).toFixed(2))}%`;

export default function GameRates() {
  const [tiers, setTiers] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    api.get("/game/rules").then(({ data }) => { if (active) setTiers(data.tiers); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, []);
  if (!tiers) return <p role="status" className="text-sm text-slate-400">{failed ? "Rates are unavailable. Reopen this page to retry." : "Loading current rates…"}</p>;
  return <section className="rounded-2xl border border-slate-700 bg-[#121721] p-4">
    <h2 className="font-semibold text-white mb-2">Current tier rates</h2>
    <p className="text-xs text-slate-400 mb-3">Wins and losses use your balance and tier at settlement. Chain commission uses each upline’s own balance when credited.</p>
    <div className="overflow-x-auto"><table className="w-full text-xs text-left whitespace-nowrap">
      <thead className="text-slate-400"><tr>{["Tier / direct referrals", "Win", "Loss", "Chain"].map((t) => <th key={t} className="pb-2 pr-3 font-medium">{t}</th>)}</tr></thead>
      <tbody>{tiers.map((tier) => <tr key={tier.name} className="border-t border-slate-800">
        <th className="py-2 pr-3 font-medium">{tier.name} <span className="text-slate-500 font-normal">{tier.max == null ? `${tier.min}+` : `${tier.min}–${tier.max}`}</span></th>
        <td className="pr-3 text-emerald-400">+{percent(tier.win_rate)}</td>
        <td className="pr-3 text-red-400">−{percent(tier.loss_rate)}</td>
        <td className="text-sky-300">{percent(tier.rate)}</td>
      </tr>)}</tbody>
    </table></div>
  </section>;
}
